import { render, staticRenderFns } from "./ImageCom.vue?vue&type=template&id=70d79abf&scoped=true&"
import script from "./ImageCom.vue?vue&type=script&lang=js&"
export * from "./ImageCom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d79abf",
  null
  
)

export default component.exports